
import { Button, Dialog, DialogContent, Grid, TextField, Theme } from '@material-ui/core';
import { SaveAlt } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import { createStyles, makeStyles } from '@material-ui/styles';

import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import Data from '../../classes/Data';
import { AppContext } from '../../context/context';
import { CampaignPostData, CampaignProps } from '../../Interfaces/Interfaces';
import List from '../List/List';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		paper: {
			boxShadow: theme.shadows[5],
			padding: theme.spacing(2, 4, 3),
		},
	}),
);

const CampaignModal = (props: CampaignProps) => {
	const classes = useStyles();
	const headers = props.headers;
	const location = useLocation().pathname.split("/")[1].toLowerCase();
	const { sharedData: { isModalActive, modalPayload }, setSharedData } = useContext(AppContext)

	const saveHandler = () => {
		//{
		//	"campaignDto": {
		//		"id": 0,
		//			"name": "string",
		//				"description": "string",
		//					"imageUrl": "string",
		//						"createdDate": "2021-03-20T21:49:10.629Z"
		//	},
		//	"missionIds": [
		//		0
		//	]
		//}
		const payload: CampaignPostData = {
			campaignDto: {
				name:"test",
				description:"testing",
				createdDate: new Date().toTimeString()
			},
			missionIds: [
				56
			]
		}
		new Data('Campaigns').POST(payload)
	}

	const closeHandler = (evt: any) => {
		setSharedData((prevState:any) => ({ ...prevState, isModalActive: !isModalActive }))
	}

	return (
		<Dialog
			className={classes.modal}
			open={isModalActive}
			//onClose={closeHandler}
			maxWidth="xl"
		>
		<DialogContent className={classes.paper} >
			{location === 'campaigns' &&
				<Grid>
					<Grid item xs={12} style={{ marginBottom: 25 }}>

						<TextField
							label="Campaign Title"
							fullWidth
							onChange={(evt) => {
								//setUpdatePayload((prevState) => ({ ...prevState, name: evt.target.value }))
							}}
							variant="outlined"
						/>
					</Grid>	
					<Grid item xs={10} >
						<TextField
							label="description"
							multiline
							fullWidth
							onChange={(evt) => {
								//setUpdatePayload((prevState) => ({ ...prevState, description: evt.target.value }))
							}}
							InputLabelProps={{
								shrink: true,
							}}
							variant="outlined"
							margin="normal"
						/>
					</Grid>	
				</Grid>	
			}
			<List target="missions" headers={headers} overide rowsChecked={modalPayload?.length > 0 ? modalPayload : undefined} />  
			{location === 'campaigns' &&
				<Grid item xs={12} style={{ marginTop: 50, marginBottom: 25 }}>
					<Grid container justify="center">
						<Grid item style={{ marginRight: 5 }}>
							<Button onClick={saveHandler} variant="contained" color="primary" size={"large"} startIcon={<SaveAlt />} >Save</Button>
						</Grid>
						<Grid item style={{ marginLeft: 5 }}>
							<Button onClick={(evt) => {
								closeHandler(evt)
								//if (isEditing) {
								//	setUpdatePayload({})
								//	setSharedData((prevState: any) => ({ ...prevState, modalPayload: [] }))
								//};
								//setIsEditing(!isEditing);
							}} variant="contained" color="secondary" size={"large"} startIcon={<ClearIcon />} >Cancel</Button>
						</Grid>
					</Grid>
				</Grid>}
			</DialogContent>
		</Dialog>
	)
}
export default CampaignModal ;
